// Staff copy for personal access tokens: Account, the person card and the audit trail.
// English only (empty az/ru) while the product is English only.
import type { Phrase } from '../staffText'

export const tokens = {
  'tokens.title': { en: 'Access tokens', az: '', ru: '' },
  'tokens.count': { en: '{n} active', az: '', ru: '' },
  'tokens.new': { en: 'New token', az: '', ru: '' },
  'tokens.none': { en: 'No tokens yet', az: '', ru: '' },
  'tokens.personNone': { en: 'No access tokens', az: '', ru: '' },

  'tokens.col.name': { en: 'Name', az: '', ru: '' },
  'tokens.col.created': { en: 'Created', az: '', ru: '' },
  'tokens.col.expires': { en: 'Expires', az: '', ru: '' },
  'tokens.col.lastUsed': { en: 'Last used', az: '', ru: '' },
  'tokens.col.state': { en: 'Status', az: '', ru: '' },

  'tokens.state.active': { en: 'Active', az: '', ru: '' },
  'tokens.state.expired': { en: 'Expired', az: '', ru: '' },
  'tokens.state.revoked': { en: 'Revoked', az: '', ru: '' },
  'tokens.never': { en: 'Never', az: '', ru: '' },
  'tokens.noExpiry': { en: 'No expiry', az: '', ru: '' },
  'tokens.days': { en: '{n} days', az: '', ru: '' },
  'tokens.neverUsed': { en: 'Never used', az: '', ru: '' },
  'tokens.lastUsedOn': { en: 'Used {when}', az: '', ru: '' },
  'tokens.expiresOn': { en: 'Expires {when}', az: '', ru: '' },

  'tokens.revoke': { en: 'Revoke', az: '', ru: '' },
  'tokens.revokeAsk': { en: 'Revoke “{name}”?', az: '', ru: '' },
  'tokens.revoked': { en: 'Token revoked', az: '', ru: '' },

  'tokens.newTitle': { en: 'New access token', az: '', ru: '' },
  'tokens.actsAsYou': { en: 'It acts as you, with your permissions.', az: '', ru: '' },
  'tokens.name': { en: 'Name', az: '', ru: '' },
  'tokens.namePlaceholder': { en: 'Claude Code on my laptop', az: '', ru: '' },
  'tokens.expiry': { en: 'Expires after', az: '', ru: '' },
  'tokens.create': { en: 'Create token', az: '', ru: '' },
  'tokens.created': { en: 'Token created', az: '', ru: '' },
  'tokens.shownOnce': { en: 'Shown once. Copy it now.', az: '', ru: '' },
  'tokens.secret': { en: 'Token', az: '', ru: '' },
  'tokens.command': { en: 'Claude Code', az: '', ru: '' },
  'tokens.copy': { en: 'Copy', az: '', ru: '' },
  'tokens.copied': { en: 'Copied', az: '', ru: '' },

  'tokens.audit.via': { en: 'Via', az: '', ru: '' },
  'tokens.audit.viaToken': { en: 'MCP/API token ({name})', az: '', ru: '' },
  'tokens.audit.tag': { en: 'Token', az: '', ru: '' },
} satisfies Record<string, Phrase>
